import { useState } from "react";
import Button from "../../../../../../../library/button";
import Modal from "../../../../../../../library/modal";
import { sendErrorNotification } from "../../../../../../../library/notification";
import DeleteModal from "./delete-modal";
import { useAuth } from "../../../../../../../AuthContext";
import { useNavigate } from "react-router-dom";
import useWorkspaceDetails from "../../../../../../../hooks/useWorkspaceDetails";

const DeleteWorkspace = () => {
  const { refreshCurrentUser } = useAuth();
  const { fetchWorkspaceDetails, resetWorkspaceDetails } =
    useWorkspaceDetails();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const onDeleteSuccess = async () => {
    resetWorkspaceDetails();
    await fetchWorkspaceDetails();
    await refreshCurrentUser();
    // Clear workspace details from Redux store
    navigate("/dashboard/account", {
      state: { notification: "workspace_under_deletion" },
    });
  };

  const onDeleteError = () => {
    closeDeleteModal();
    sendErrorNotification("Kunne ikke slette arbeidsmiljø.");
  };

  return (
    <>
      <Button onClick={openDeleteModal} color="red" variant="regular">
        Slett alt innhold
      </Button>
      <Modal
        onClose={closeDeleteModal}
        open={showDeleteModal}
        title="Slett arbeidsmiljø"
        size={560}
      >
        <DeleteModal onError={onDeleteError} onSuccess={onDeleteSuccess} />
      </Modal>
    </>
  );
};

export default DeleteWorkspace;
